import { TractorStatus } from "../tractors/TractorViewModel.model";

// Reuse TractorStatus enum for trailer status
export type TrailerStatus = TractorStatus;

export class TrailerViewModel {
  id: string | number;
  dateCreatedUtc: string;
  dateDeletedUtc: string;
  isActive: boolean;
  status: TrailerStatus = TractorStatus.Available;
  trailerNo: string;
  unitNumber: string; // Alias for trailerNo for consistency
  equipmentCode: string;
  trailerType: string;
  year: number;
  make: string;
  model: string;
  mobileDeviceType: string;
  mobileDeviceNumber: string;
  serial: string;
  vinNo: string;
  terminalLocation: string;
  currentLocationState: string;
  currentLocationCity: string;
  /** When Fleetilla location was last updated (from FleetillaWorker). */
  fleetillaLocationUpdatedUtc?: Date;
  purchasedDate: Date;
  purchasePrice: number;
  dateSold: Date;
  insuranceName: string;
  insurancePolicyNumber: string;
  notes: string;
  picture: string;
  driverId: string;
  driver?: any;
  unNumbers?: string; // For UN Numbers field
  // Specs fields
  length: string;
  width: string;
  height: string;
  ladenWeight: string;
  unladenWeight: string;
  axles: string;
  tireSize: string;
  engineHours: string;
  // License fields
  stateOfRegistration: string;
  licenseNumber: string;
  licenseExpirationDate: Date;
  // Maintenance fields
  nextAnnualService: Date;
  nextFiveYearService: Date;
}
